import {i18n} from "@/plugins/i18n";
import { userCategoriesStatus} from "@/constants/userCategoriesStatus";


export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 40,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.fullname'),
        sortable: true,
        template: (row) => {
            return '<a href="/users/' + row.id + '/details">'+row.full_name+'</a>'
        },
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'birth_date',
        title: i18n.t('label.birth_date'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'site_address',
        title: i18n.t('label.site_address'),
        sortable: false,
        width: 90,
        textAlign: 'center',
        template: (row) => {
            return '<a href="http://' + row.site_address + '">' + row.site_address + '</a>';
        },
    },
    {
        field: 'group',
        title: i18n.t('label.group'),
        sortable: true,
        width: 85,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'user_level',
        title: i18n.t('label.user_level'),
        sortable: true,
        width: 85,
        textAlign: 'center',
    },
    {
        field: 'total_wage',
        title: i18n.t('label.wage') + ' (' + i18n.t('label.rial') + ')',
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
]
